import Vue from 'vue';
import VueRouter from "vue-router";
Vue.use(VueRouter)
const routes = [
    { path: '*', redirect: '/screen1' },
    { path: '/screen1', component: () => import("../src/views/screen1.vue"), },
    { path: '/screen2', component: () => import("../src/views/screen2.vue"), },
    { path: '/carousel', component: () => import("../src/views/carousel.vue"), },
]

// 3. 创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
    mode: "hash",
    routes
})

export default router;
